import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, EffectFade } from 'swiper/modules';
import increaseProductImage from "./increaseProductImage";

export default function initSlideShow() {

	let swiperPagination = new Swiper(".product-gallery-pagination", {
		direction: "vertical",
		spaceBetween: 0,
		slidesPerView: 'auto',
		modules: [Navigation, Pagination],
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			1201: {
				slidesPerView: 'auto',
			},
			768: {
				slidesPerView: 5,
			},
		}
	});

	let swiperGallery = new Swiper(".product-gallery", {
		loop: true,
		modules: [Navigation, Pagination, Thumbs, EffectFade],
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		effect: "fade",
		thumbs: {
			swiper: swiperPagination,
		},
	});

	let incrFn = increaseProductImage();
	swiperPagination.on("init", function() {
		incrFn();
	});
	swiperGallery.on('slideChange', function() {
		document.dispatchEvent(new CustomEvent('gallerySlideChange'));
	});
};
